import { render, staticRenderFns } from "./StudyDesign.vue?vue&type=template&id=fb6226ea&"
import script from "./StudyDesign.vue?vue&type=script&lang=js&"
export * from "./StudyDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb6226ea')) {
      api.createRecord('fb6226ea', component.options)
    } else {
      api.reload('fb6226ea', component.options)
    }
    module.hot.accept("./StudyDesign.vue?vue&type=template&id=fb6226ea&", function () {
      api.rerender('fb6226ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/Editor/Study/StudyDesign.vue"
export default component.exports